module.exports = __webpack_public_path__ + "static/media/fly0013.95e7f25b.webp";